import { ProfileRecommendationsRoot } from "../apis/profile-recommendations";
import { Catalog } from "../apis/search-catalog";

type RecommendedService =
  ProfileRecommendationsRoot["servicos_recomendados"][number];

const slugToTitle = (slug: string) =>
  slug
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

function toFallbackCatalog(service: RecommendedService): Catalog {
  return {
    type: "CATALOG",
    title: service.titulo || slugToTitle(service.slug),
    slug: service.slug,
    description: service.descricao || service.motivo || "",
    tags: [],
    isFree: true,
    isOnline: true,
    isDigital: true,
    category: service.categoria || "",
    targets: [],
    department: "",
    departmentSections: [],
    categorySlug: (service.categoria || "").toLowerCase().replace(/\s+/g, "-"),
    highlighted: false,
    score: 0,
    imageUrl: "",
    icon: service.icone || "",
    link: service.link || "",
    resultTotal: 0,
    accessProfile: undefined,
    isSelfService: true,
    catalogDataRow: [],
  };
}

export function mapProfileRecommendationsToCatalog(
  data: ProfileRecommendationsRoot | null,
  allCatalogList: Catalog[] = []
): Catalog[] {
  const services = data?.servicos_recomendados ?? [];

  return services
    .map((service) => {
      const match = allCatalogList.find(
        (catalog) => catalog.slug === service.slug
      );

      return match ?? toFallbackCatalog(service);
    })
    .filter((catalog) => {
      const match = allCatalogList.find((item) => item.slug === catalog.slug);

      if (match?.categorySlug && match?.slug) {
        return true;
      }

      return Boolean(catalog.link?.trim());
    });
}
